export default __webpack_public_path__ + "8ce919da3cba35099039692121e9d1cf.png";